// searchsync-powered-by-component.js

import { poweredBy } from 'instantsearch.js/es/widgets';
import { getInstance, registerWidget } from './searchsync-create-instance';

/**
 * Powered By: mounts Algolia's official "Search by Algolia" logo (InstantSearch's `poweredBy`
 * widget) at the `[data-filter-type='poweredBy']` element. Config-less apart from an optional
 * light/dark logo theme. Algolia requires this on free plans; the user opts in by placing the
 * widget (see class-powered-by-shortcode-generator.php's docblock).
 */
function initPoweredByWidget() {
  const tgblAlgoliaDataJSON = window.atob( tgblSearchsyncDataEncoded );
  const tgblAlgoliaData = jQuery.parseJSON( tgblAlgoliaDataJSON );

  const elements = document.querySelectorAll( "[data-filter-type='poweredBy']" );

  elements.forEach( ( element ) => {
    const indexName = element.getAttribute( 'data-index' );
    if ( ! indexName ) return;

    const search = getInstance( indexName );
    if ( ! search ) return;

    const widgetID = element.getAttribute( 'data-id' );
    const widgetData = tgblAlgoliaData[ widgetID ] || {};
    const theme = widgetData.theme === 'dark' ? 'dark' : 'light';

    search.addWidgets( [ poweredBy( { container: element, theme } ) ] );
    registerWidget( element );
  } );
}

export { initPoweredByWidget };